export default __webpack_public_path__ + "img/cb111ab0eb12b1e046ae0aa92f21ac01.png";